import { render, staticRenderFns } from "./RecievedRequests.vue?vue&type=template&id=0c53f6c8&"
import script from "./RecievedRequests.vue?vue&type=script&lang=js&"
export * from "./RecievedRequests.vue?vue&type=script&lang=js&"
import style0 from "./RecievedRequests.vue?vue&type=style&index=0&id=0c53f6c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports